import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class UserProfile extends Event {
    eventName = 'oms_userProfile';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for get user profile
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.userProfile;
        data.multi_call_key = (data.multi_call_key) ? data.multi_call_key : 'user_profile';
        data.canUsePublicAuth = false;
        data.data = {};
    
        // send request
        this.sendRequest(data, function (response) {
          if (response) {
            //add data to storage
            let userData = new LocalStorage.UserData(clientId);
            userData.setData(response);

            //format response data
            let data = thisObj.formatResponseData(response);

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
          }
        });
    }
}

export default UserProfile;